import { useState } from "react";
import Modal from "../Modal/Modal";
import { Link, useNavigate } from "react-router-dom";
import { signOut } from "supertokens-auth-react/recipe/session";


export default function CookiesModal() {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState<boolean>(() => {
      return localStorage.getItem('accepted_cookies') !== 'true';
    });

    const handleReject = async () => {
      await signOut();
      navigate("/auth");
    }

    const handleAccept = () => {
      setIsOpen(false);
      localStorage.setItem('accepted_cookies', 'true');
    }

    return (
      <Modal title="Lo de las cookies 🍪" isOpen={isOpen} onClose={() => setIsOpen(false)} hasCloseBtn={false} content={
        <>
          <p>
            En ALSE usamos las cookies🍪 <b>estrictamente necesarias</b> para poder gestionar el correcto funcionamiento de la app.
          </p>
          <p>
            <span className="emoji">✅</span> <b>SÍ</b> usamos las cookies para mantener tu <b>inicio de sesión</b>.<br/>
            <span className="emoji">❌</span> <b>NO</b> usamos las cookies para <b>rastrearte</b>.<br/>
            <span className="emoji">❌</span> <b>NO</b> usamos las cookies para mostrarte <b>publicidad</b> de ningún tipo.
          </p>
          <p>
            Para más información visita nuestra <Link to="/politica-de-cookies">política de cookies</Link>.
          </p>
          <div className="d-flex justify-content-end">
            <button className={"btn ml-3"} onClick={handleReject}>
              Rechazar y salir
            </button>
            <button className={"btn info"} onClick={handleAccept}>
              Aceptar
            </button>
          </div>
        </>
      }/>
    );
};

